module.exports = __webpack_public_path__ + "static/media/heroimage_igib-005.a828700b.jpg";